/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfoDto } from './InfoDto';
import {
    InfoDtoFromJSON,
    InfoDtoFromJSONTyped,
    InfoDtoToJSON,
} from './InfoDto';

/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    imageUrl: string;
    /**
     * 
     * @type {InfoDto}
     * @memberof ProductDto
     */
    info?: InfoDto;
}

/**
 * Check if a given object implements the ProductDto interface.
 */
export function instanceOfProductDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "imageUrl" in value;

    return isInstance;
}

export function ProductDtoFromJSON(json: any): ProductDto {
    return ProductDtoFromJSONTyped(json, false);
}

export function ProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'price': json['price'],
        'imageUrl': json['imageUrl'],
        'info': !exists(json, 'info') ? undefined : InfoDtoFromJSON(json['info']),
    };
}

export function ProductDtoToJSON(value?: ProductDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'price': value.price,
        'imageUrl': value.imageUrl,
        'info': InfoDtoToJSON(value.info),
    };
}

